import Vue from 'vue'
import Router from 'vue-router'
import constantRoutes from './baseRouter.js'
Vue.use(Router)
import Layout from '@/layout'
const createRouter = () => new Router({
  scrollBehavior: () => ({
    y: 0
  }),
   routes: constantRoutes
})
const router = createRouter()
export default router
